import React from 'react';
import FormROValue from "../../../library/form/components/FormROValue1";
import FormButton from "../../../library/form/components/FormActionButton2";
import FormInput from '../../../library/form/components/FormInput';
import DocChildActivator from "../../cmn/DocChildActivator";
import SarasTrans from '../../../library/notifications/SarasTrans';

const InvItemDiscountRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <div className="phViewAreaItem uiBoxItem phViewContent uiBlackContainer">
            <div className="phViewName">
                <FormROValue className="uiBold" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemCode" }} />
                <FormROValue className="uiSpacerH5" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />
            </div>
            <div className="phViewInfo">
                <div className="phKeyValueView">
                    <div className="uiSpacerH5">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemDesc" }} />
                    </div>
                </div>
            </div>
            <div className="phViewQty">
                <SarasTrans value="Discount" />
                <FormInput formObject={formObject} className="uiInput uiVal40 uiSpacerH5" rowKey={rowKey}
                    action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "unitPrice", actionParam: { formulaSource: "UP", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
            </div>
            <div className="phViewAction uiActionBlock">
                <DocChildActivator formObject={formObject} rowKey={rowKey}
                    action={{ actionId: "show", paramName: "childComp", actionParam: {}, containerKey: "popup" }}
                />
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    className="" 
                    action={{ actionId: "edit", paramName: "editBtn", actionParam: { pathKey: "#pathKey" }, containerKey: "popup" }}
                ></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    className=""
                    action={{ actionId: "del", paramName: "delBtn", actionParam: {}, containerKey: "row" }}
                ></FormButton>
            </div>
        </div>
    )
}

export default InvItemDiscountRow
